<template>
  <div class="app-main-content" type="primary">
    <div
      class="grid-view"
    >
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="3100"
          :reset="true"
          :custom-search-items="customSearchItems"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <!-- 航线确认 -->
            <el-button
              type="primary"
              @click="routeConfirmationHandler"
            >{{ this.$t('CargoMsg.Cargo_RouteConfirmation') }}
            </el-button>
            <el-button
              type="primary"
              @click="cancelRouteConfirmationHandler"
            >{{ this.$t('CargoMsg.Cargo_Cancel') + this.$t('CargoMsg.Cargo_RouteConfirmation') }}
            </el-button>
            <!-- 订舱完成 -->
            <el-button
              type="primary"
              @click="bookingCompletionHandler(1)"
            >{{ this.$t('CargoMsg.Cargo_BookingCompletion') }}
            </el-button>
            <el-button
              type="primary"
              @click="bookingCompletionHandler(0)"
            >{{ this.$t('CargoMsg.Cargo_Cancel') + this.$t('CargoMsg.Cargo_BookingCompletion') }}
            </el-button>
            <!-- 二次确认 -->
            <el-button
              type="primary"
              @click="secondaryConfirmationHandler"
            >{{ this.$t('CargoMsg.Cargo_SecondaryConfirmation') }}
            </el-button>
            <el-button
              type="primary"
              @click="cancelSecondaryConfirmationHandler"
            >{{ this.$t('CargoMsg.Cargo_Cancel') + this.$t('CargoMsg.Cargo_SecondaryConfirmation') }}
            </el-button>
            <!-- 航线标记 -->
            <el-button
              type="primary"
              @click="routeMarkingHandler"
            >{{ this.$t('CargoMsg.Cargo_RouteMarking') }}
            </el-button>
            <!-- 航班改配 -->
            <el-button
              type="primary"
              @click="flightReassignmentHandler"
            >{{ this.$t('CargoMsg.Cargo_FlightReassignment') }}
            </el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="250522"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :deselect-sub-record="true"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="250521"
            :total="filter.total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>

    <route-detail
      v-if="routeDetailWindow.visible"
      ref="routeDetail"
      :visible.sync="routeDetailWindow.visible"
      :rows="routeDetailWindow.rows"
      :title="routeDetailWindow.title"
      :job-uuid="routeDetailWindow.jobUuid"
      :secondary-confirmation="routeDetailWindow.secondaryConfirmation"
      @close="routeDetailWindow.visible = false"
      @refresh="toQuery"
    />

    <!--  批量修改部分字段  -->
    <change-data-window
      v-if="changeDataWindow.visible"
      :visible.sync="changeDataWindow.visible"
      :uuids="changeDataWindow.uuids"
      :type="changeDataWindow.type"
      :title="changeDataWindow.title"
      @close="changeDataWindow.visible = false"
      @refresh="toQuery"
    />

  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  advancedQuery, updateRouteBookingFunc
} from '@/api/AirExport/airExportJob'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { queryAirlineProductDownList } from '@/api/booking/airlineProduct'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import RouteDetail from '@/views/cargo/v0/AirExport/components/routeBooking/routeDetail.vue'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import ChangeDataWindow from '@/views/cargo/v0/AirExport/components/routeBooking/changeDataWindow.vue'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { doJumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'

export default {
  name: 'RouteBooking',
  components: {
    ChangeDataWindow,
    RouteDetail,
    searchItem
  },
  data() {
    return {
      URL,
      isAdvancedQuery: false, // 是否为高级查询
      pageCount: 0,
      customSearchItems: [],
      airlineProductDownList: [],
      SystemConstants: SystemConstants,
      changeDataWindow: {
        visible: false,
        title: '',
        type: 0,
        uuids: []
      },
      filter: {
        conditions: [],
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      routeDetailWindow: {
        jobUuid: null,
        title: '',
        secondaryConfirmation: false,
        rows: [],
        visible: false
      },
      templateName: null,
      filterJson: {},
      selectData: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          colId: 'mbl',
          field: 'mbl',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              if (currentJob.lclMasterUuid) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              const currentJob = params.data
              if (Number(currentJob.dataType) === 2 && currentJob.lclMasterUuid) { // 二级小票
                return `<span>${currentJob.hawb}</span>`
              }
              return `<span>${params.value}</span>`
            }
          }
        },
        context: {
          componentParent: this
        },
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_SeparateNumber'),
          colId: 'hawb',
          field: 'hawb',
          hide: true,
          width: 150
        },
        { headerName: this.$t('CargoMsg.Cargo_OrderNumber'), field: 'jobNo', width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              return {
                useRoute: true,
                usePrint: false,
                jumpMethod: value => {
                  doJumpFinaceOrBusiness(this, value, 'AE', this.$store.getters.currentOfficeId, true)
                }
              }
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RouteConfirmationStatus'),
          colId: 'routeConfirmationStatus',
          field: 'routeConfirmationStatus',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.ROUTE_CONFIRMATION_LIST) // 航线确认状态
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_IsBookingCompleted'),
          colId: 'bookingCompletion',
          field: 'bookingCompletion',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceProduct'),
          colId: 'serviceProduct',
          field: 'serviceProduct',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirServiceProduct, 'productId', params.value, 'productName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirlineProductCode'),
          colId: 'airlineProductName',
          field: 'airlineProductName',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Airline2'),
          colId: 'carrierId',
          field: 'carrierId',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_6') : ''
          }
        },
        { headerName: this.$t('SeaExport.OperateType'), field: 'operateType', width: 180, colId: 'operateType',
          cellRenderer: (params) => {
            return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
          },
          filter: false,
          filterParams: {}
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FlightNumber'),
          colId: 'voyageFlight',
          field: 'voyageFlight',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FlightDate'),
          colId: 'etd',
          field: 'etd',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OriginPort'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PurchaseMethod'),
          colId: 'purchaseMethodName',
          field: 'purchaseMethodName',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PurchaseSource'),
          colId: 'purchaseSourceName',
          field: 'purchaseSourceName',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RouteOfficer'),
          colId: 'airlineOperator',
          field: 'airlineOperator',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RouteConfirmationPerson'),
          colId: 'routeConfirmationUser',
          field: 'routeConfirmationUser',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RouteConfirmationTimeRange'),
          colId: 'routeConfirmationDate',
          field: 'routeConfirmationDate',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      rowData: []
    }
  },
  computed: {},
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    }
  },
  beforeMount() {
    setTimeout(() => {
      this.toQuery()
    }, 0)
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.init()
  },
  methods: {
    async init() {
      // 初始化 航线产品下拉列表
      await queryAirlineProductDownList({ containVoyage: false, branchId: this.$store.getters.currentOfficeId }).then(res => {
        this.airlineProductDownList = res.data
      })
      this.customSearchItems = await this.getCustomSearchItems()
    },
    async getCustomSearchItems() {
      const defaultSearchFields = []
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 0
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_TEXT2'
      searchField.itemName = 'airExportJob.AIRLINE_PRODUCT_UUID'
      searchField.itemLabel = 'CargoMsg.Cargo_AirlineProductCode'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.tagName = 'name'
      searchField.tagValue = 'uuid'
      searchField.lock = false
      searchField.defaultValue = null
      searchField.dataProvider = this.airlineProductDownList
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword
        this.filter.conditions = []
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading4Cxt()
      this.filter.conditions = this.addConditionsBeforeQuery([])
      this.filter.requires = ['routeBooking']
      advancedQuery(this.filter).then((res) => this.handleQueryData(res)).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      for (const row of this.rowData) {
        if (this.airlineProductDownList) {
          const data = this.airlineProductDownList.filter(p => p.uuid === row.airlineProductUuid)
          if (data && data.length > 0) {
            const vo = data[0]
            row.airlineProductName = vo.name // 航线产品名称
            row.purchaseMethodName = ColumnUtils.showTypeLabelFunc(vo.purchaseMethod, SystemConstants.PURCHASE_METHODS)
            row.purchaseSourceName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', vo.purchaseSource, 'chineseName')
            row.airlineOperator = ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_User, 'userId', vo.airlineOperator, 'chineseName') // 航线员
          }
        }
        if (row.operateType === AirExportConstants.DIRECT.code || row.operateType === AirExportConstants.BACK_TO_BACK.code) {
          row.masterFlag = true
        }
      }
      this.pageCount = res.data.pages
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = data
        // 高级查询条件组装
        this.filter.conditions = this.addConditionsBeforeQuery(data)
        this.filter.pageNum = 1
      }
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.requires = ['routeBooking']
      this.fullscreenLoading = getLoading4Cxt()
      advancedQuery(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      if (typeof data === 'undefined') return
      // 业务状态
      const jobStates = [SystemConstants.STATE_OPERATING.code]
      const option = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, AdvancedSearchConsts.OPERATOR_IN.code)
      data.push(option.formatObj2Json())
      return data
    },
    // 航线确认
    routeConfirmationHandler() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      let masterSize = 0
      let masterJobKey = ''
      let codeByOne = ''
      let hasError = false
      for (const data of items) {
        if (data.routeConfirmationStatus !== SystemConstants.ROUTE_CONFIRMATION_0.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DataNotPendingConfirmation') + data.jobNo)
          return
        }
        // if (data.bookingCompletion) {
        //   this.$message.warning(this.$t('CargoMsg.Cargo_BookingCompleted') + data.jobNo)
        //   return
        // }
        if (data.masterFlag) {
          masterJobKey = data.uuid
          masterSize += 1
        }
        const code = data.loadingPortCode + '_' + data.destinationPortCode
        if (!codeByOne || codeByOne === code) {
          codeByOne = code
        } else {
          hasError = true
        }
      }
      if (masterSize > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectOneMasterBill'))
        return
      }
      this.routeDetailWindow.title = this.$t('CargoMsg.Cargo_RouteConfirmation')
      this.routeDetailWindow.rows = items
      this.routeDetailWindow.jobUuid = masterJobKey
      this.routeDetailWindow.secondaryConfirmation = false
      if (hasError) {
        this.$confirm(this.$t('CargoMsg.Cargo_PortMismatch'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.routeDetailWindow.visible = true
        }).catch(() => { })
      } else {
        this.routeDetailWindow.visible = true
      }
    },
    // 取消确认
    cancelRouteConfirmationHandler() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      for (const data of items) {
        if (data.routeConfirmationStatus !== SystemConstants.ROUTE_CONFIRMATION_1.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DataNotConfirmed') + data.jobNo)
          return
        }
        // if (data.bookingCompletion) {
        //   this.$message.warning(this.$t('CargoMsg.Cargo_BookingCompleted') + data.jobNo)
        //   return
        // }
      }
      this.loading = getLoading4Cxt()
      const params = {
        keys: items.map(item => item.uuid),
        type: 4
      }
      updateRouteBookingFunc(params).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_CancelConfirmCompleted'))
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 订舱完成
    bookingCompletionHandler(bookingCompletion) {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      // for (const data of items) {
      //   if (bookingCompletion && data.bookingCompletion) {
      //     this.$message.warning(this.$t('CargoMsg.Cargo_BookingCompleted') + data.jobNo)
      //     return
      //   }
      // }
      this.loading = getLoading4Cxt()
      const params = {
        keys: items.map(item => item.uuid),
        type: 1,
        bookingCompletion: bookingCompletion
      }
      updateRouteBookingFunc(params).then(res => {
        let text = ''
        if (!bookingCompletion) {
          text = this.$t('CargoMsg.Cargo_Cancel')
        }
        this.$message.success(text + this.$t('CargoMsg.Cargo_BookingCompletion'))
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 二次确认
    secondaryConfirmationHandler() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      let masterSize = 0
      let masterJobKey = ''
      for (const data of items) {
        if (data.masterFlag) {
          masterJobKey = data.uuid
          masterSize += 1
        }
        if (data.routeConfirmationStatus !== SystemConstants.ROUTE_CONFIRMATION_1.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_RouteNotConfirmedOrDoubleConfirmed') + data.jobNo)
          return
        }
        // if (data.bookingCompletion) {
        //   this.$message.warning(this.$t('CargoMsg.Cargo_BookingCompleted') + data.jobNo)
        //   return
        // }
      }
      if (masterSize > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectOneMasterBill'))
        return
      }
      this.routeDetailWindow.title = this.$t('CargoMsg.Cargo_SecondaryConfirmation')
      this.routeDetailWindow.rows = items
      this.routeDetailWindow.jobUuid = masterJobKey
      this.routeDetailWindow.secondaryConfirmation = true
      this.routeDetailWindow.visible = true
    },
    // 取消二次确认
    cancelSecondaryConfirmationHandler() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      for (const data of items) {
        if (data.routeConfirmationStatus !== SystemConstants.ROUTE_CONFIRMATION_2.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DataNotRouteDoubleConfirmed') + data.jobNo)
          return
        }
        // if (data.bookingCompletion) {
        //   this.$message.warning(this.$t('CargoMsg.Cargo_BookingCompleted') + data.jobNo)
        //   return
        // }
      }
      this.loading = getLoading4Cxt()
      const params = {
        keys: items.map(item => item.uuid),
        type: 5
      }
      updateRouteBookingFunc(params).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_CancelConfirmCompleted'))
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 航线标记
    routeMarkingHandler() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      for (const data of items) {
        if (data.routeConfirmationStatus === SystemConstants.ROUTE_CONFIRMATION_0.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DataNotConfirmed') + data.jobNo)
          return
        }
      }
      this.changeDataWindow.title = this.$t('CargoMsg.Cargo_Modify') + this.$t('CargoMsg.Cargo_RouteMarking')
      this.changeDataWindow.uuids = items.map(item => item.uuid)
      this.changeDataWindow.type = 0
      this.changeDataWindow.visible = true
    },
    // 航班改配
    flightReassignmentHandler() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      for (const data of items) {
        if (data.routeConfirmationStatus === SystemConstants.ROUTE_CONFIRMATION_0.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DataNotConfirmed') + data.jobNo)
          return
        }
      }
      this.changeDataWindow.title = this.$t('CargoMsg.Cargo_Modify') + this.$t('CargoMsg.Cargo_FlightReassignment')
      this.changeDataWindow.uuids = items.map(item => item.uuid)
      this.changeDataWindow.type = 1
      this.changeDataWindow.visible = true
    }
  }
}
</script>
